import { render, staticRenderFns } from "./AppAccordionItem.vue?vue&type=template&id=f34d5698&scoped=true"
import script from "./AppAccordionItem.vue?vue&type=script&lang=js"
export * from "./AppAccordionItem.vue?vue&type=script&lang=js"
import style0 from "./AppAccordionItem.vue?vue&type=style&index=0&id=f34d5698&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f34d5698",
  null
  
)

export default component.exports